// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_exn from "../../../../node_modules/rescript/lib/es6/js_exn.js";
import * as Json__Decode from "../../../../node_modules/rescript-json/lib/es6_global/src/Json__Decode.bs.js";
import * as Generic$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/utils/Generic.bs.js";
import * as Shopify$Showside from "./Shopify.bs.js";
import * as FetchUtils$Showside from "./FetchUtils.bs.js";
import * as RescriptJsonUtils$Showside from "./RescriptJsonUtils.bs.js";
import * as Settings_GaVersionCodecs$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/Settings/Settings_GaVersionCodecs.bs.js";
var t_decode = Curry._5(Generic$ApiTypes.Decode.map4, Curry._2(Generic$ApiTypes.Decode.field, "gaTrackingId", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string)), Generic$ApiTypes.Decode.fieldWithDefault("gaVersion", Settings_GaVersionCodecs$ApiTypes.GaVersion.fromJson, /* Gtag */1), Curry._2(Generic$ApiTypes.Decode.field, "checkoutLink", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string)), Curry._2(Generic$ApiTypes.Decode.field, "historyEnabled", Generic$ApiTypes.Decode.bool), function (gaTrackingId, gaVersion, checkoutLink, historyEnabled) {
  return {
    gaTrackingId: gaTrackingId,
    gaVersion: gaVersion,
    checkoutLink: checkoutLink,
    historyEnabled: historyEnabled
  };
});
var Settings = {
  t_decode: t_decode
};
var t_decode$1 = Json__Decode.map3(Json__Decode.field("id", Json__Decode.string), Json__Decode.field("accountId", Json__Decode.option(Json__Decode.string)), Json__Decode.field("settings", t_decode), function (id, accountId, settings) {
  return {
    id: id,
    accountId: accountId,
    settings: settings
  };
});
function load(smartnavApiHost) {
  var shop = Shopify$Showside.getShop(undefined);
  if (shop === undefined) {
    return Promise.reject(Js_exn.raiseError("Shopify store not found"));
  }
  if (shop === "") {
    return Promise.reject(Js_exn.raiseError("Shopify store not found"));
  }
  var url = smartnavApiHost + "/api/get_shopify_url_config?url=" + encodeURIComponent("https://" + shop);
  return FetchUtils$Showside.$$fetch(undefined, undefined, undefined, undefined, FetchUtils$Showside.Server.ignoreNotFoundError, async function (json) {
    return RescriptJsonUtils$Showside.decode(json, t_decode$1);
  }, url);
}
var fromJson = t_decode$1;
export { Settings, t_decode$1 as t_decode, fromJson, load };
/* t_decode Not a pure module */